module.exports = __webpack_public_path__ + "img/clogo21.1f6cc821.png";